<template>
  <div>
    <div class="config-wrapper">
      <div class="config-wrapper__review-top">
        <aside class="config-wrapper__share">
          <div class="mobile-only">
            <button @click="$router.go(-1)" class="mobile-back">
              <span class="sr-only">Back</span>
            </button>
          </div>
          <div class="desktop-only">
            <button @click="$router.go(-1)" class="desktop-back btn btn--left btn--has-border">Back</button>
          </div>

          <Share :generic-share="true" class="m-t-md" />
        </aside>
        <div class="config-wrapper__canvas">
          <router-view name="canvas" />
        </div>
      </div>
      <div class="config-wrapper__content">
        <router-view name="completed" />
      </div>
    </div>
    <div class="additional-content features">
      <h2 class="additional-content__heading features__heading">Key Features</h2>
      <ul class="additional-content__list features__list">
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/magicbutton.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">All-New Magic Button</h3>
          <p>Play, pause and skip tracks directly on the speaker. Just push for convenient control of any streaming music. Or simply set up one-touch playlists for Apple Music® and Deezer® Premium via the app.</p>
          <a
            class="feature__link js--video"
            href="https://www.youtube.com/watch?v=R-oXFiKNgdc"
          >More about Magic Button</a>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/partyup.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">Party Up</h3>
          <p>Pair 2 speakers for stereo sound, or 150+ to get LOUD. Works with all BOOM and MEGABOOM speakers, even with previous generations.</p>
          <a
            class="feature__link"
            :href="`https://www.ultimateears.com/${locale}/features/party-up.html`"
            target="_blank"
          >More about Party Up</a>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/powerup.png" alt />
          <h3
            class="additional-content__sub-heading feature__heading"
          >Charge Wirelessly with Power Up</h3>
          <p>Throw Power Up charging dock (sold separately) into your basket, so you can grab-and-go with BOOM 3, fully charged, to your next musical adventure.</p>
          <a
            class="feature__link"
            :href="`https://www.ultimateears.com/${locale}/wireless-speakers/power-up.html`"
            target="_blank"
          >More about Power Up</a>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/battery.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">15 Hours</h3>
          <p>myBoom 3 runs on the same battery technology as some of the most crave-worthy electric cars. myBOOM 3 will stay powered and pumping tunes for 15 hours* on a single charge.</p>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/app.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">App</h3>
          <p>Use your App to download the features like Block Party, PartyUp Remote On/Off, Customizable EQ, Musical Alarm, Tap Controls and more.</p>
          <a
            class="feature__link"
            :href="`https://www.ultimateears.com/${locale}/features/apps.html`"
            target="_blank"
          >More about the App</a>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/waterproof.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">Waterproof &amp; Floats</h3>
          <p>myBoom 3 was born to get wet and is completely waterproof. Boasting an insane IP67 water and dustproof rating, it can be totally submerged in water for up to 30-minutes. When it pops back to the surface–because it floats too–it will still be booming loud and proud.</p>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/durable.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">Durable Fabric</h3>
          <p>myBOOM 3 is covered in a fabric that’s as tough as it is hot-damn beautiful. Engineered for applications like motorcycle jackets and fire equipment, this performance textile is built for extremes.</p>
        </li>
        <li class="additional-content__item features__item feature">
          <img class="feature__image" src="/images/features/drop-proof.png" alt />
          <h3 class="additional-content__sub-heading feature__heading">Drop Proof</h3>
          <p>myBOOM 3 is purpose built to handle life's thrills and spills. It’s passed more than 25 seriously tough durability tests, including thousands of button pushes, 100s of tumbles, multiple drop tests at 5 feet (1.5 meter) height, and more. So party on friend. From rooftop-raging to mountaintop-shredding myBOOM 3's got ya back.</p>
        </li>
        <li class="additional-content__item features__item feature feature--warranty">
          <h3 class="feature__warranty">
            <span>2</span> Year Warranty
          </h3>
        </li>
      </ul>
    </div>
    <div class="additional-content specifications">
      <h2 class="additional-content__heading specifications__heading">Specifications</h2>
      <div class="specifications__images">
        <div class="spec spec-a">
          <img src="/images/specs/Boom3_A_image.png" alt />
        </div>
        <div class="spec spec-b">
          <img src="/images/specs/Boom3_B_image.png" alt />
        </div>
        <div class="spec spec-c">
          <img src="/images/specs/Boom3_C_image.png" alt />
        </div>
      </div>
      <ul class="additional-content__list specifications__list">
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Customizable EQ</h3>
          <p>Select the best Sound for different occasions with 4 different presets and a customized tuner.</p>
        </li>
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Power</h3>
          <p>Rechargeable Lithium-Ion Battery for up to 15 hours of battery life* between Micro USB charges.</p>
        </li>
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Audio</h3>
          <p>Maximum Sound Level: 90dBA. Frequency Range: 90Hz - 20kHz. Drivers: Two 2” drivers and two 2” x 4” Passive Radiators.</p>
        </li>
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Wireless Capabilities</h3>
          <p>
            Pair up to 8
            <i>Bluetooth</i> enabled source devices - Connect up to two source devices at the same time. Mobile range of play is up to 45m (150 ft).
          </p>
        </li>
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Compatibility</h3>
          <p>
            For Audio Playback: Smartphones, tablets and other devices that support
            <i>Bluetooth</i> and
            <i>Bluetooth</i> Smart® wireless audio profile [Advanced Audio Distribution Profile (A2DP)]
          </p>
        </li>
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Dimensions</h3>
          <p>
            Diameter: 73 mm (2.8”).
            <br />Height: 184 mm (7.2”).
            <br />Weight: 608 g (1.34 lb)
          </p>
        </li>
        <li class="additional-content__item specifications__item specification">
          <h3 class="additional-content__sub-heading specification__heading">Warranty</h3>
          <p>2-year limited hardware warranty</p>
        </li>
      </ul>
    </div>
    <div class="disclaimers">
      <p>* Actual battery life will vary with use, settings and environmental conditions.</p>
    </div>
  </div>
</template>

<script>
import store from "../store";
import ConfigNavigation from "../components/ConfigNavigation.vue";
import Share from "../components/Share.vue";
import VueCookies from "vue-cookies";
export default {
  name: "completed-design",
  created() {
    // if we already have data in the store we shouldn't read a cookie
    if (this.$store.state.configuration.Fabric === null) {
      let queryKeys = [];
      if (this.$route.query) {
        queryKeys = Object.keys(this.$route.query);
      }
      if (queryKeys.length <= 0 && VueCookies.isKey("UEB_Configuration")) {
        const configuration = VueCookies.get("UEB_Configuration");
        let configKeys = Object.keys(configuration);
        configKeys.forEach(option => {
          if (option === "engravingText") {
            const customText = decodeURIComponent(configuration[option]);
            store.commit("updateCustomText", customText);
          } else {
            store.commit("selectOption", {
              CategoryName: option,
              Id: configuration[option]
            });
          }
        });
      } else {
        // if we don't have something saved, check if we have a configuration.
        // if we do, fine. if we don't, go back to homepage
        if (
          !this.$store.state.configuration.Fabric &&
          queryKeys.indexOf("Fabric") < 0
        ) {
          this.$router.push({
            name: "home"
          });
        }
      }
    }
  },
  mounted() {
    document.querySelector("html").classList.remove("full-page");
    $(".js--video").magnificPopup({
      type: "iframe",
      closeMarkup:
        '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
      fixedContentPos: true,
      iframe: {
        patterns: {
          youtube: {
            index: "youtube.com/", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

            id: "v=", // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }

            src:
              "//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0&modestbranding=1"
          }
        }
      }
    });
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    }
  },
  methods: {},
  components: { Share }
};
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";
.m-t-md {
  margin-top: 1.5em;
}

.desktop-back {
  display: block;
}
.mobile-back {
  border: none;
  background: transparent none;
  padding: 0;
  text-decoration: none;
  color: currentColor;
  display: block;
  cursor: pointer;
  &:after {
    content: "\F104";
    font-family: FontAwesome;
    font-size: 50px;
  }
}

.config-wrapper {
  max-width: 1280px;
  background: #fff;
  padding-top: 75px;
  padding-left: 1.5em;
  padding-right: 1.5em;
  padding-bottom: 2em;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 992px) {
    display: flex;
    padding: 95px 2em 2em;
    background: transparent;
    justify-content: center;
    align-items: flex-start;
  }
  &__review-top {
    position: relative;
    height: calc(100% - 100px);
    @media (min-width: 992px) {
      width: 60%;
      position: static;
      margin-right: 50px;
    }
    @media (min-width: 1200px) {
      margin-right: 100px;
    }
  }
  &__share {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    @media (min-width: 992px) {
      position: static;
      transform: none;
      display: block;
      padding-top: 100px;
      float: left;
      width: 92px;
    }
  }
  &__canvas {
    float: none !important;
    width: 100%;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: 991px) {
      @media (min-aspect-ratio: 1/2) and (max-height: 700px) {
        max-width: 250px;
      }
    }

    @media (min-width: 992px) {
      width: calc(100% - 92px);
      max-width: none;
      margin-left: auto;
      margin-right: 0;
    }
  }
  &__content {
    text-align: center;
    //max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 992px) {
      width: 40%;
      padding-top: 100px;
      max-width: 400px;
      margin: 0;
      text-align: left;
    }
  }
}

.additional-content {
  padding: 3em 2em;
  @media (min-width: 992px) {
    padding: 100px 2em;
  }
  &__heading {
    font-size: 0.87em;
    text-transform: uppercase;
    text-align: center;
    font-weight: normal;
    margin-bottom: 3rem;
    @media (min-width: 992px) {
      margin-bottom: 5rem;
    }
  }
  &__sub-heading {
    font-size: 1.35em;
    line-height: 1.3;
    margin-bottom: 1rem;
    text-transform: uppercase;
    @media (min-width: 992px) {
      font-size: 1.75em;
    }
  }
  &__list {
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    @media (min-width: 992px) {
      justify-content: space-between;
    }
  }
  &__item {
    margin-bottom: 3em;
  }
  i {
    font-style: italic;
  }
  p {
    font-family: sans-serif;
    line-height: 1.38;
  }
}

.features {
  background: #fff;
  &__item {
    @media (min-width: 600px) and (max-width: 991px) {
      width: calc(50% - 1em);
      &:nth-child(odd) {
        margin-right: 1em;
      }
      &:nth-child(even) {
        margin-left: 1em;
      }
    }
    @media (min-width: 992px) {
      width: 30%;
    }
  }
}
.feature {
  &__image {
    margin-bottom: 1rem;
  }
  &__heading {
    font-size: 1.35em;
    line-height: 1.3;
    margin-bottom: 1rem;
    text-transform: uppercase;
    @media (min-width: 992px) {
      font-size: 1.75em;
    }
  }
  &__link {
    font-size: 0.87em;
    text-transform: uppercase;
    display: inline-block;
    font-weight: bold;
    text-decoration: none;
    color: currentColor;
    margin-top: 1rem;
    line-height: 1.38;
    border-bottom: 3px solid currentColor;
    transition: all 0.3s;
    &:hover {
      border-color: $greyMidDark;
    }
  }
  &__warranty {
    font-size: 1.35em;
    text-transform: uppercase;
    @media (min-width: 992px) {
      font-size: 1.75em;
    }
    span {
      font-size: 100px;
      display: block;
      font-weight: normal;
      margin-bottom: 1rem;
    }
  }
}
.share {
  display: none;
  @media (min-width: 992px) {
    display: block;
  }
}
.specifications {
  &__images {
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3rem;

    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 3rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    @media (min-width: 800px) {
      display: flex;
      justify-content: space-around;
      margin-bottom: 5rem;
      align-items: flex-start;
      img {
        max-height: 400px;
        margin: 0;
        max-width: none;
      }
    }
    @media (min-width: 992px) {
      img {
        max-height: none;
      }
    }
  }
  &__list {
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    &:after {
      content: "";
      @media (min-width: 430px) and (max-width: 991px) {
        width: calc(50% - 1em);
        &:nth-child(odd) {
          margin-right: 1em;
        }
        &:nth-child(even) {
          margin-left: 1em;
        }
      }
      @media (min-width: 992px) {
        width: 21%;
        max-width: 250px;
      }
    }
  }
  &__item {
    @media (min-width: 430px) and (max-width: 991px) {
      width: calc(50% - 1em);
      &:nth-child(odd) {
        margin-right: 1em;
      }
      &:nth-child(even) {
        margin-left: 1em;
      }
    }
    @media (min-width: 992px) {
      width: 21%;
      max-width: 250px;
    }
  }
}
.specification {
  &__heading {
    font-size: 1.25em;
  }
  p {
    color: $greyDark;
  }
}
.disclaimers {
  max-width: 1230px;
  margin-left: auto;
  margin-right: auto;
  font-family: sans-serif;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 2rem;
  font-size: 0.75em;
  line-height: 1.38;
  color: $greyDark;
}

.spec {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent none center center no-repeat;
  }
  img {
    max-width: 100%;
  }
}
.spec-a {
  &:after {
    background-image: url("/images/specs/Boom3_A_Notation.svg");
  }
}
.spec-b {
  &:after {
    background-image: url("/images/specs/Boom3_B_Notation.svg");
  }
}
.spec-c {
  &:after {
    background-image: url("/images/specs/Boom3_C_Notation.svg");
  }
}
</style>